import React from 'react';
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap';

// Para poder comparar tiempos se usa el epoch, por lo que para representar las fechas
// correspondientes se transforman en una ISO string de la que sólo nos quedamos con los 10
// primeros caracteres, que son los que las proporcionan y además ya están en el formato que
// requiere el input.

const TimeFilter = ({ dateRangeStart, dateRangeEnd, changeRangeStart, changeRangeEnd }) => {
  return (
    <Form.Row className="pt-1">
      <Form.Group as={Col} className="my-0">
        <Form.Row>
          <Form.Label column sm={2}>
            From:
          </Form.Label>
          <Col sm={10}>
            <Form.Control
              type="date"
              name="dateRangeStart"
              value={dateRangeStart}
              min={new Date(0).toISOString().slice(0, 10)}
              max={dateRangeEnd}
              onChange={event => {
                event.persist();
                changeRangeStart(event.target.value);
              }}
            />
          </Col>
        </Form.Row>
      </Form.Group>
      <Form.Group as={Col} className="my-0">
        <Form.Row>
          <Form.Label column sm={2}>
            to:
          </Form.Label>
          <Col sm={10}>
            <Form.Control
              type="date"
              name="dateRangeEnd"
              value={dateRangeEnd}
              min={dateRangeStart}
              max={new Date().toISOString().slice(0, 10)}
              onChange={event => {
                event.persist();
                changeRangeEnd(event.target.value);
              }}
            />
          </Col>
        </Form.Row>
      </Form.Group>
    </Form.Row>
  );
};

TimeFilter.propTypes = {
  dateRangeStart: PropTypes.string.isRequired,
  dateRangeEnd: PropTypes.string.isRequired,
  changeRangeStart: PropTypes.func.isRequired,
  changeRangeEnd: PropTypes.func.isRequired
};

export default TimeFilter;
